import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      getDischargeActivityCodes: 'activitiesStore/getDischargeActivityCodes',
    }),
  },
  methods: {
    isDischargeActivity(code) {
      const dischargeActivityCodes = this.getDischargeActivityCodes;
      if (dischargeActivityCodes && dischargeActivityCodes.length > 0) {
        return dischargeActivityCodes.includes(code);
      }
      return false;
    },
    emitEndVoyageDischargeEvent() {
      this.$emit('openEndVoyageDischargeDialog');
    },
  },
};
